import { Component, OnInit } from '@angular/core';
import { Guid } from 'guid-typescript';
import { FileModel } from '@shared/models/file-model';
import { takeUntil } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { getFileModel } from '@shared/store/selectors/file-store.selector';
import { Observable, Subject } from 'rxjs';
import { UploadFileAction } from '@shared/store/actions/file-store.actions';
import { IFileStoreState } from '@shared/store/reducers/file-store.reducer';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-import-field-from-template-dialog',
  templateUrl: './import-field-from-template-dialog.component.html',
  styleUrls: ['./import-field-from-template-dialog.component.scss']
})
export class ImportFieldFromTemplateDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  FileToUpload: File;
  fileModel$: Observable<FileModel>;
  unsubscribe$ = new Subject<void>();
  fileUploadState: any;
  worksheets: any;
  constructor(private store: Store<IFileStoreState>) {
  }

  ngOnInit() {
  }

  onFileChange($event) {
    console.log($event);
    const directoryPath = `Root/${Guid.create().toString()}/Uploads`;
    const key = Guid.create().toString();
    const fileModel = FileModel.createClientFileModel(directoryPath, this.FileToUpload, key);
    this.fileModel$ = this.store.pipe(select(getFileModel, key));
    this.fileModel$.pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state && state.fileId) {
        this.data.input.fileId = state.fileId;
        this.data.input.fullPath = state.fullPath;
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        this.fileUploadState = state;
      }
    });
    this.store.dispatch(new UploadFileAction(key, this.FileToUpload, fileModel, true));
  }

  onOkClicked(): boolean {
    return true;
  }
}
